module.exports = __webpack_public_path__ + "img/cerrar.47af5ce6.svg";